/**
 * Application constants
 */

export const SKILLS = [
  'JavaScript',
  'CSS',
  'SASS',
  'ES6',
  'Bootstrap',
  'HTML',
  'React',
  'GIT',
  'NPM',
  'JSON',
  'REST',
  'NODE',
  'Express',
];

export const NAVIGATION_LINKS = [
  { href: '#home', label: 'Home' },
  { href: '#skills', label: 'Skills' },
  { href: '#projects', label: 'Projects' },
  { href: '#contact', label: 'Contact' },
];

export const SCROLL_REVEAL_OFFSET = 150;

export const CONTACT_EMAIL = 'abhisheksrinivasan5@gmail.com';

